import type { IconData } from '@stacksjs/iconify-core'

export const handFiist: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M23.62 13.72v1.52h3.05v4.57h1.52V9.14h-1.52v4.58zm1.52 9.14H9.91v-1.52H8.38v1.52H6.86v4.57h21.33v-4.57h-1.52v-3.05h-1.53Zm0 3.05H22.1v-1.53h3.04Zm0-18.29h1.53v1.52h-1.53Zm-3.04 6.1h1.52v-6.1h1.52V6.1H22.1zm-3.05 0h3.05v1.52h-3.05Zm-7.62 1.52H16v1.52h-4.57Zm1.52-6.1h-1.52v1.53h3.05V6.1h3.05v4.57h-3.05v1.52H16v3.05h1.53v-1.52h1.52V6.1h3.05V4.57H9.91V6.1h3.04zm-3.04 4.58h1.52v1.52H9.91Z\"/><path fill=\"currentColor\" d=\"M11.43 9.14V7.62H9.91V6.1H8.38v1.52H6.86v1.52zM6.86 19.81h1.52v1.53H6.86Zm-1.52-3.05h1.52v3.05H5.34Zm0-7.62h1.52v1.53H5.34Zm-1.53 1.53h1.53v6.09H3.81Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default handFiist
